import type { LocalPosition } from "./local-api.ts";

// A deliberately broad map viewport, never a substitute tracker location.
export const overviewRegion = Object.freeze({ latitude: 56, longitude: 12, latitudeDelta: 25, longitudeDelta: 35 });

// Public regional overview, not a reported or synthetic tracker position.
export const googleMapsOverviewUrl = "https://www.google.com/maps/@?api=1&map_action=map&center=56%2C12&zoom=5&basemap=roadmap";

export function trackerMapModel(position: LocalPosition | null) {
  const valid = position?.gpsValid === 1 &&
    typeof position.latitude === "number" && Number.isFinite(position.latitude) && Math.abs(position.latitude) <= 90 &&
    typeof position.longitude === "number" && Number.isFinite(position.longitude) && Math.abs(position.longitude) <= 180;
  const point = valid ? { latitude: position.latitude!, longitude: position.longitude! } : null;
  return { point, region: point ? { ...point, latitudeDelta: 0.008, longitudeDelta: 0.008 } : overviewRegion };
}

export function googleMapsPositionUrl(position: LocalPosition | null) {
  const { point } = trackerMapModel(position);
  return point ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${point.latitude},${point.longitude}`)}` : null;
}

// onMapReady means SDK initialization, not that any map tiles have rendered.
export function mapLoadStatusKey(ready: boolean, loaded: boolean, slow: boolean) {
  return loaded ? "map.renderReported" : slow ? "map.tilesStalled" : ready ? "map.tilesLoading" : "map.loading";
}
